// Display state constants matching the API enum
export const DisplayState = {
  PENDING: 0,
  IN_PROGRESS: 1,
  DONE: 2,
  PRINTED: 3,
  CANCELLED: 4,
};

// Helper functions to work with display states
export const getStatusText = (displayState) => {
  switch (displayState) {
    case DisplayState.PENDING:
      return "Pendiente";
    case DisplayState.IN_PROGRESS:
      return "En Preparación";
    case DisplayState.DONE:
      return "Completado";
    case DisplayState.CANCELLED:
      return "Cancelado";
    default:
      return "Desconocido";
  }
};

export const getStatusColor = (displayState) => {
  switch (displayState) {
    case DisplayState.IN_PROGRESS:
      return "warning";
    case DisplayState.PENDING:
      return "primary";
    case DisplayState.DONE:
      return "success";
    case DisplayState.CANCELLED:
      return "error";
    default:
      return "default";
  }
};

export const getStatusIcon = (displayState) => {
  switch (displayState) {
    case DisplayState.IN_PROGRESS:
      return "🟡";
    case DisplayState.PENDING:
      return "🔵";
    case DisplayState.DONE:
      return "🟢";
    case DisplayState.CANCELLED:
      return "🔴";
    default:
      return "⚪";
  }
};

export const getNextStatus = (currentStatus) => {
  switch (currentStatus) {
    case DisplayState.PENDING:
      return DisplayState.IN_PROGRESS;
    case DisplayState.IN_PROGRESS:
      return DisplayState.DONE;
    case DisplayState.DONE:
      return DisplayState.IN_PROGRESS;
    case DisplayState.CANCELLED:
      return DisplayState.PENDING;
    default:
      return DisplayState.PENDING;
  }
};

export const getPreviousStatus = (currentStatus) => {
  switch (currentStatus) {
    case DisplayState.IN_PROGRESS:
      return DisplayState.PENDING;
    case DisplayState.DONE:
      return DisplayState.IN_PROGRESS;
    case DisplayState.CANCELLED:
      return DisplayState.DONE;
    default:
      return DisplayState.PENDING;
  }
};

export const getCurrentState = (orders, mesaId) => {
  const order = orders.find((o) => o.idMesa === mesaId);

  if (!order || order.products?.length === 0) return 0;

  const firstState = order.products[0].displayState;
  return order.products?.every((item) => item.displayState === firstState)
    ? firstState
    : "mixed";
};
